@if (!showSingleStep) {
  <p-stepper [value]="(activeStepValue$ | async) ?? 0" (valueChange)="onActiveIndexChange($event)">
    <p-step-list>
      @for (step of steps$ | async; track step.id) {
        <p-step [value]="$index + 1">{{ step.label }}</p-step>
      }
    </p-step-list>
  </p-stepper>
} @else {
  <div class="flex grow justify-center text-xl">
    {{ (activeStep$ | async)?.label }} ({{ activeStepValue$ | async }}/{{ (steps$ | async)?.length ?? 1 }})
  </div>
  <p-progressBar [style]="{ height: '1rem' }" mode="determinate" class="pb-3" [value]="progressBarValue$ | async" />
}
<s-form-page
  #wizardPage
  id="wizardPage"
  [formGroup]="form"
  [apiError]="apiError"
  [schema]="schema"
  [submitting$]="submitting$"
  [showBack]="(activeStepIndex$ | async) !== 0"
  [showNext]="showLastNext || ((activeStepIndex$ | async) ?? 0) < ((steps$ | async)?.length ?? 0) - 1"
  class="flex w-full grow px-2 pt-1 flex-col h-full overflow-y-auto"
  [backLabel]="backLabel"
  [backLabel$]="backLabel$"
  [showSave]="showSave"
  [saveLabel]="saveLabel"
  [saveLabel$]="saveLabel$"
  [nextLabel]="nextLabel"
  [nextLabel$]="nextLabel$"
  (back)="priorStep()"
  (next)="nextStep()"
  (save)="triggerSave()"
>
  <!--
  [class.overflow-hidden]="(activeStep$ | async)?.vCenterMd || (activeStep$ | async)?.vCenter"
  [class.md:h-full]="(activeStep$ | async)?.vCenterMd"
  [class.h-full]="(activeStep$ | async)?.vCenter"
  -->
  <div
    class="flex grow flex-col w-full max-w-full"
    [class.md:justify-center]="(activeStep$ | async)?.vCenterMd"
    [class.justify-center]="(activeStep$ | async)?.vCenter"
    [class.items-center]="(activeStep$ | async)?.hCenter"
  >
    @if ((isCurrentPreRendered$ | async) === false) {
      <ng-container
        *ngTemplateOutlet="page; context: { template: displayTemplate$ | async, step: activeStep$ | async }"
      />
    }
    @for (stepTemplate of preRenderSteps$ | async; track stepTemplate) {
      <div [class.hidden]="stepTemplate.wizardStep !== (activeStepId$ | async)">
        <ng-container
          *ngTemplateOutlet="page; context: { template: stepTemplate.template, step: getStep(stepTemplate.wizardStep) }"
        />
      </div>
    }
  </div>
  @if (footer) {
    <ng-template #footer [ngTemplateOutlet]="footer"></ng-template>
  }
</s-form-page>

<!-- Logic to Render the Wizard Page -->
<ng-template #page let-template="template" let-step="step">
  @switch (step?.layout ?? stepLayouts.Custom) {
    @case (stepLayouts.Buttons) {
      <ng-container *ngTemplateOutlet="buttonPage; context: { step: step }" />
    }
    @case (stepLayouts.Field) {
      <ng-container *ngTemplateOutlet="fieldPage; context: { step: step }" />
    }
    @case (stepLayouts.File) {
      <ng-container *ngTemplateOutlet="filePage; context: { step: step }" />
    }
    @default {
      <ng-container [ngTemplateOutlet]="template" />
    }
  }
</ng-template>

<ng-template #buttonPage let-step="step">
  @if (step?.title) {
    <h2>{{ step?.title }}</h2>
  }
  @if (step?.subTitle) {
    <span class="text-l mb-3">{{ step?.subTitle }}</span>
  }
  @for (row of step.inputLayout; track $index) {
    <div class="m-2">
      @for (cell of row; track $index) {
        <p-button
          [label]="cell.label"
          [icon]="form.value[cell.field] === cell.value ? 'pi check' : undefined"
          [text]="form.value[cell.field] !== cell.value"
          class="m-2"
          [raised]="true"
          (click)="setAndGo(cell.field, cell.value)"
        />
      }
    </div>
  }
</ng-template>

<ng-template #fieldPage let-step="step">
  @if (step?.title) {
    <h2>{{ step?.title }}</h2>
  }
  @if (step?.subTitle) {
    <span class="text-l mb-3">{{ step?.subTitle }}</span>
  }
  <!--grid or with input requirements-->
  @if (step?.inputLayout) {
    <div>
      @for (row of step.inputLayout; track row) {
        <div class="m-2">
          @for (cell of row; track cell) {
            @if ((applicableFields$ | async)?.includes(cell.field)) {
              <s-form-input [fieldName]="cell.field" [form]="form" [apiError]="apiError" [schema]="schema" />
            }
          }
        </div>
      }
    </div>
  } @else {
    <!--flat fields-->
    <div>
      @for (field of step.fields; track field) {
        <div>
          @if ((applicableFields$ | async)?.includes(field)) {
            <s-form-input [fieldName]="field" [form]="form" [apiError]="apiError" [schema]="schema" />
          }
        </div>
      }
    </div>
  }
</ng-template>

<ng-template #filePage let-step="step">
  @if (step?.title) {
    <h2>{{ step?.title }}</h2>
  }
  @if (step?.subTitle) {
    <span class="text-l mb-3">{{ step?.subTitle }}</span>
  }
  <!-- test #:{{ (testMessages$ | async)?.['length'] }}<br />
  <div class="trucante !max-w-full">test2:<br />{{ testMessages$ | async | json }}</div> -->
  <!--grid or with input requirements-->
  <!--file types-->
  @if (!step?.inputLayout) {
    @for (fileType of step.fileTypes; track fileType) {
      <div class="flex grow flex-col w-full">
        <div class="flex flex-row grow justify-center">
          <p-button
            label="Attach Pic"
            [icon]="defaultIcon.Attach"
            (click)="attachContentType($event, fileType)"
            [raised]="true"
            [autofocus]="false"
            [buttonProps]="{ autofocus: false }"
          />
        </div>
        <s-form-file-viewer
          [files$]="fileRefs$"
          class="max-w-full"
          [contentTypes]="[fileType]"
          [fileUpload]="fileUpload"
          [showDelete]="true"
        />
        @if (fileRefs$ | async; as fileRefs) {
          @if (fileRefs.length === 0) {
            <div class="flex flex-col grow justify-center items-center w-full">
              <div>Having issues attaching a Pic?</div>
              <div><p-button text="true" label="Click Here to fix" (onClick)="refresh()" /></div>
            </div>
          }
        }
      </div>
    }
  }
</ng-template>
